import { Input } from "@legacy/Input";
import Search from "@mui/icons-material/Search";
import { useEffect, useState } from "react";

/**
 * Input search
 * @deprecated
 * @param {String} props.id
 * @param {Object} props.filter
 * @param {Object} props.filterWrapper - {search, otherfilter:{}} - search for input text and otherfilter for special filter
 * @param {Function} props.onFilter
 * @param {Boolean} props.disabled
 * @param {Function} props.onBlur
 * @param {Object} props.style
 * @param {String} props.placeholder
 */
export const SearchInput = (props) => {
  const {
    id,
    filter = {},
    filterWrapper,
    onChange,
    onFilter,
    disabled,
    style,
    placeholder,
    delay,
    iconColor,
    ...rest
  } = props;
  const [searchValue, setSearchValue] = useState(filter[filterWrapper.search]);

  useEffect(() => {
    if (filter[filterWrapper.search] !== undefined) {
      setSearchValue(filter[filterWrapper.search]);
    }
  }, [filter, filterWrapper]);

  const handleKeyPress = (evt) => {
    if (evt.key === "Enter") {
      evt.preventDefault();
      if (typeof searchValue === "string" && searchValue.trim() !== filter[filterWrapper.search]) {
        onFilter({ ...filter, [filterWrapper.search]: searchValue.trim() });
      }
    }
  };

  const handleBlur = () => {
    if (typeof searchValue === "string" && searchValue.trim() !== filter[filterWrapper.search]) {
      onFilter({ ...filter, [filterWrapper.search]: searchValue.trim() });
    }
  };

  const handleChange = (evt) => {
    if (typeof onChange === "function") {
      onChange(evt);
    }
    setSearchValue(evt.target.value);
  };

  return (
    <Input
      id={id}
      data-testid={id}
      value={searchValue || ""}
      disabled={disabled}
      role="searchbox"
      type="text"
      onChange={handleChange}
      placeholder={placeholder || "Recherche"}
      icon={<Search color={iconColor || undefined} />}
      onBlur={handleBlur}
      onKeyPress={handleKeyPress}
      version="new"
      color={"primary"}
      margin="dense"
      fullWidth
      {...style}
      {...rest}
    />
  );
};
